// Listino dei trattamenti: durate e prezzi dal menù stampato (docs/MENU-STAMPATO.md), copiati dal prototipo.
// Prezzo a persona: la coppia paga il doppio. null = prezzo non ancora noto (si scrive a mano).
// sala: sala dove si fa di solito · solo: true = solo per una persona (niente coppia, Aura Suite)
// nascosto: non si sceglie nelle prenotazioni nuove · durataDaConf: durata ancora da confermare.
// Funzioni pure: niente pagina, niente database.

const T = (cat, id, nome, durata, prezzo = null, extra = {}) => ({ cat, id, nome, durata, prezzo, ...extra });

export const LISTINO = Object.freeze([
  T('Suite', 'flow-suite', 'Flow Suite – Rilascio', 150, 300, { sala: 'flow' }),
  T('Suite', 'aura-suite', 'Aura Suite – Equilibrio', 120, 250, { sala: 'aura', solo: true }),
  T('Suite', 'harmonia-suite', 'Harmonia Suite – Rigenerazione', 120, 250, { sala: 'harmonia' }),
  // AMAÏ: il rituale lo sceglie l'operatrice dopo lo scalp check, per questo c'è anche «da scegliere».
  T('Scalp care AMAÏ', 'amai-120', 'AMAÏ – rituale da scegliere (scalp check)', 120, 230),
  T('Scalp care AMAÏ', 'amai-pure-120', 'AMAÏ Pure Balance (purificante)', 120, 230),
  T('Scalp care AMAÏ', 'amai-calm-120', 'AMAÏ Deep Calm (lenitivo)', 120, 230),
  T('Scalp care AMAÏ', 'amai-energy-120', 'AMAÏ Energy Flow (rinforzante)', 120, 230),
  T('Scalp care AMAÏ', 'amai-150', 'AMAÏ + corpo 25\' – rituale da scegliere', 150, 300),
  T('Scalp care AMAÏ', 'amai-pure-150', 'AMAÏ Pure Balance + corpo 25\'', 150, 300),
  T('Scalp care AMAÏ', 'amai-calm-150', 'AMAÏ Deep Calm + corpo 25\'', 150, 300),
  T('Scalp care AMAÏ', 'amai-energy-150', 'AMAÏ Energy Flow + corpo 25\'', 150, 300),
  T('Viso', 'gold', 'Gold Beauty – Eastern Facelift', 90, 230),
  T('Viso', 'solaria', 'Solaria (vitamina C)', 50, 150),
  T('Viso', 'janas', 'Janas (retinolo)', 50, 150),
  T('Viso', 'maestrali', 'Maestrali (uomo)', 50, 150),
  T('Corpo signature', 'longevity-60', 'Longevity Wellness Sardinia (massaggio)', 60, 150),
  T('Corpo signature', 'longevity-90', 'Longevity Wellness Sardinia + esfoliazione e avvolgimento', 90, 180),
  T('Corpo signature', 'luci', 'Rituale Luci (sale marino)', 50, 120),
  T('Corpo signature', 'biohack-60', 'Bio-Hacking Mediterranea (massaggio)', 60, 150),
  T('Corpo signature', 'biohack-90', 'Bio-Hacking Mediterranea + esfoliazione e avvolgimento', 90, 180),
  T('Massaggi corpo', 'essentzia', 'Essentzia (rilassante)', 50, 130),
  T('Massaggi corpo', 'oltremare', 'Oltremare (decontratturante, deep tissue)', 50, 150),
  T('Massaggi corpo', 'sardinia', 'Sardinia (aromaterapico)', 50, 130),
  T('Massaggi corpo', 'sanima-50', 'S\'anima (personalizzato)', 50, 150),
  T('Massaggi corpo', 'ammare', 'Ammare (californiano)', 50, 150),
  T('Massaggi corpo', 'riu', 'Riu (drenante)', 50, 150),
  T('Massaggi corpo', 'riflessu', 'Riflessu (riflessologia plantare)', 50, 150),
  T('Massaggi viso', 'hikari', 'Hikari (Kobido)', 50, 130),
  T('Massaggi viso', 'nagomi', 'Nagomi (Gua Sha)', 50, 150),
  T('Fuori listino (dal foglio Excel)', 'sanima-90', 'S\'anima personalizzato', 90, 200),
  T('Fuori listino (dal foglio Excel)', 'deep', 'Deep tissue (nel menù = Oltremare)', 50, 150, { nascosto: true }),
  T('Fuori listino (dal foglio Excel)', 'coppia-30', 'Massaggio di coppia', 30),
  T('Fuori listino (dal foglio Excel)', 'relax-30', 'Massaggio relax', 30),
  T('Fuori listino (dal foglio Excel)', 'decontr-30', 'Decontratturante', 30),
  T('Fuori listino (dal foglio Excel)', 'headspa-90', 'Head spa', 90),
  T('Fuori listino (dal foglio Excel)', 'headspa-rid', 'Head spa ridotta', 60, null, { durataDaConf: true }),
  T('Fuori listino (dal foglio Excel)', 'scrub', 'Scrub & Massaggio', 90, null, { durataDaConf: true }),
  T('Fuori listino (dal foglio Excel)', 'nd', 'Trattamento non scritto nel foglio', 50, null, { nascosto: true, durataDaConf: true }),
].map((t) => Object.freeze(t)));

/** Listino indicizzato per id: { 'essentzia': {…}, … }. Accetta anche un listino diverso (es. dal database). */
export function indiceListino(listino = LISTINO) {
  return Object.fromEntries(listino.map((t) => [t.id, t]));
}

export const TRATTAMENTI = Object.freeze(indiceListino());

/** Il trattamento con quell'id, o null. */
export const trattamento = (id, indice = TRATTAMENTI) => indice[id] || null;

/** Categorie nell'ordine del menù. */
export const categorie = (listino = LISTINO) => [...new Set(listino.map((t) => t.cat))];

/** Voci da mostrare nella scelta: tolte quelle nascoste, tranne quella già scelta (modifica di una vecchia prenotazione). */
export const visibili = (scelto = null, listino = LISTINO) => listino.filter((t) => !t.nascosto || t.id === scelto);
